import { useField } from 'remix-validated-form'
import { AppConfig } from '~/AppConfig';
import type { PasswordFieldProps } from '~/components/shared/PasswordField';
import { PasswordField } from '~/components/shared/PasswordField'

const PasswordInput = (props: PasswordFieldProps) => {
  const { name, helperText, defaultValue, ...restProps } = props
  const { error, getInputProps } = useField(name || '', {
    validationBehavior: AppConfig.InputValidationBehavior
  })

  return <PasswordField
    {...getInputProps({
      error: Boolean(error),
      helperText: error || helperText || '',
      ...restProps
    })}
    defaultValue={defaultValue}
  />
}

export default PasswordInput
